import { createContext } from 'react';

import type { NLeavePageProvider } from '@app/providers/LeavePageProvider/LeavePageProvider.types';

export const LeavePageContext = createContext<NLeavePageProvider.State>({
  initialData: [],
  newData: [],
  startedData: [],
  setInitialData: () => {},
  setNewData: () => {},
  prepareStartedData: () => {},
  checkIsDataUpdated: () => false,
  handleMenuClick: () => {},
  setInputData: () => {},
  setSelectorData: () => {},
  setCheckboxData: () => {},
  setDatePickerData: () => {},
  setSwitchData: () => {},
  setPhoneCountryIdForLeavePageProvider: () => {},
  setPhoneNumberBody: () => {},
});
